import { render, staticRenderFns } from "./UserSearchAndHistory.vue?vue&type=template&id=20d04dde&scoped=true&"
import script from "./UserSearchAndHistory.vue?vue&type=script&lang=js&"
export * from "./UserSearchAndHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchAndHistory.vue?vue&type=style&index=0&id=20d04dde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d04dde",
  null
  
)

export default component.exports